(function () {
  var root = document.querySelector(".ss-blog");
  if (!root) return;

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var reveals = root.querySelectorAll(".ss-reveal");

  function showAll() {
    reveals.forEach(function (el) {
      el.classList.add("ss-visible");
    });
  }

  function initReveal() {
    if (!reveals.length) return;

    if (reducedMotion) {
      showAll();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("ss-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px 0px 0px" }
    );

    reveals.forEach(function (el) {
      observer.observe(el);
    });

    // Fallback: never leave content hidden if observer misses
    window.setTimeout(showAll, 800);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReveal);
  } else {
    initReveal();
  }
})();
